<template>
  <div>
    <span v-if="countdown != 0">{{remoteTime | formateTime(countdown) | timeFactory}}</span>
  </div>
</template>

<script>
import { get } from '@/utils/ajax'
import { isValidServerTime } from '@/utils/serverTime'
export default {
  name: 'Countdown',
  props: {
    remoteTime: Number
  },
  data() {
    return {
      countdown: 0,
      originTime: 0,
      timer: null,
      syncVersion: 0,
      disposed: false
    }
  },
  filters: {
    // 页面倒计时
    formateTime (value, countdown) {
      const time = value - countdown
      return time
    },
    // 倒计时格式化
    timeFactory (timestamp) {
      if (timestamp < 0) {
        return '00 : 00 : 00'
      }
      timestamp = timestamp / 1000
      // let d = parseInt(timestamp / (24 * 60 * 60))
      let h = Math.floor(timestamp / 3600)
      let m = Math.floor(timestamp / 60 % 60)
      let s = Math.floor(timestamp % 60)
      // d = d < 10 ? 0 + '' + d : d
      h = h < 10 ? 0 + '' + h : h
      m = m < 10 ? 0 + '' + m : m
      s = s < 10 ? 0 + '' + s : s
      return h + ' : ' + m + ' : ' + s
    }
  },
  mounted () {
    this.syncTime()
  },
  methods: {
    async syncTime() {
      const version = ++this.syncVersion
      clearInterval(this.timer)
      this.timer = null
      this.$emit('sync-state', false)
      try {
        const time = await get('/home/common/times', {}, { ignoreMsg: true })
        if (this.disposed || version !== this.syncVersion) return
        if (!isValidServerTime(time)) throw new Error('Invalid server time')
        const startedAt = performance.now()
        this.originTime = time
        this.$emit('sync-state', true)
        this.startTime(0)
        this.timer = setInterval(() => {
          this.startTime(performance.now() - startedAt)
        }, 1000)
      } catch (error) {
        if (!this.disposed && version === this.syncVersion) {
          this.$emit('sync-state', false)
        }
      }
    },
    startTime (accuracy) {
      if (this.disposed) return
      this.countdown = this.originTime + accuracy
      this.$emit('listen', this.originTime + accuracy)
    }
  },
  beforeDestroy () {
    this.disposed = true
    this.syncVersion++
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>
